import { filterDuplicateJourneyClick } from './initializer';
import { installJourneyActivation } from './activation';
import type { ClickAnalyticsLike } from '../telemetry';

export * from './envelope';
export * from './registry';
export { applyDeferredRetirement, installJourneyActivation, openBlankFormCreation, recordBlankFormCreationStep, recordClaimedBlankFormCreationStep, recordStep, startCreateOrganizationStage, startOrStep, startStage, startUpgradeStage, JOURNEY_SELECTOR } from './activation';
export type { StepOptions } from './activation';
export { filterDuplicateJourneyClick } from './initializer';

type TelemetryInitializerHost = {
	addTelemetryInitializer: (initializer: (item: { data?: Record<string, unknown> }) => boolean | void) => unknown;
};

/**
 * Wires up customer journey telemetry: the capture-phase listener that opens stages and emits their Start
 * and Step events, and the initializer that suppresses the Click Analytics plugin's duplicate.
 *
 * Call this once at module scope alongside the App Insights instance — there is no API for removing a
 * telemetry initializer, so calling it per route would accumulate them.
 */
export function installJourneyTelemetry(
	appInsights: TelemetryInitializerHost | null,
	getClickAnalytics: () => ClickAnalyticsLike | null
): void {
	if (!appInsights)
		return;
	appInsights.addTelemetryInitializer(filterDuplicateJourneyClick);
	installJourneyActivation(getClickAnalytics);
}
